// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".company-navbar .v-toolbar__content{padding:0 0 0 16px!important;border-bottom:1px solid #e0e0e0!important;border-bottom:1px solid var(--grey-2,#e0e0e0)!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
